export const generateFilterAndRecordID = ({
  id,
  option,
  supervision,
  setFilterID,
  setRecordID
}) => {
  const filterID = [];
  const recordID = [];
  const supervisionId = supervision?._id || id;
  filterID.push(option._id);
  recordID.push(supervisionId);

  setFilterID(filterID);
  setRecordID(recordID);
};
